export const iconFontAwesomeMapsWifi = (
	<i className="fa-solid fa-wifi"></i>
);
